import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var Name = 'user-action';
export var UserAction = Name;
/**
 * See Readme for more information.
 * @typedef Data
 * @prop {string[]} metaHierarchy Description of user's action
 * @prop {number} numberValue Metric
 */

/**
 * Utility for dispatching the user-action event.
 * @param {string[]} metaHierarchy Description of user's action.
 * @param {number} numberValue Optional metric data.
 */
export function dispatch(metaHierarchy, numberValue) {
  window.dispatchEvent(new CustomEvent(Name, {
    detail: _objectSpread({
      metaHierarchy: metaHierarchy
    }, numberValue !== undefined && {
      numberValue: numberValue
    })
  }));
}